export const es = {
  common: {
    login: "Iniciar Sesión",
    register: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    logout: "Cerrar Sesión",
    enterEmail: "Ingrese su dirección de correo electrónico",
    enterPassword: "Ingrese su contraseña",
    loginCredentials: "Por favor ingrese sus credenciales para continuar",
    invalidEmail: "Dirección de correo electrónico inválida",
    dontHaveAccount: "¿No tienes una cuenta?",
    signUp: "Regístrate",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    signIn: "Iniciar sesión",
    name: "Nombre",
    enterName: "Ingrese su nombre",
    confirmPassword: "Confirmar Contraseña",
    enterConfirmPassword: "Confirme su contraseña",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    registerSuccess: "¡Registro exitoso! Por favor inicie sesión.",
  },
  sidebar: {
    analyzeDocument: "Analizar Documento",
    directory: "Directorio",
    users: "Usuarios",
    settings: "Configuración",
    prompts: "Indicaciones",
  },
  dashboard: {
    title: "Panel de Control",
    analyzeDocument: "Analizar Documento",
    metadata: "Metadatos",
  },
  directory: {
    title: "Directorio",
    listTitle: "Directorio",
  },
  settings: {
    title: "Configuración",
  },
  users: {
    title: "Usuarios",
    listTitle: "Usuarios",
  },
  prompts: {
    title: "Indicaciones",
    listTitle: "Lista de Indicaciones Personalizadas",
    createPrompt: "Crear Indicación",
    filters: "Filtros",
    clearFilters: "Limpiar Filtros",
    filterCategory: "Categoría",
    filterSection: "Sección",
    filterStatus: "Estado",
    all: "Todos",
  },
  language: {
    english: "Inglés",
    spanish: "Español",
  },
  buttons: {
    export: "Exportar",
    aiAnalyze: "Análisis IA",
    addDocument: "Por favor agregue un documento para analizar con Alt-Ai.",
    importDocument: "Importar documento",
    edit: "Editar",
    save: "Guardar",
    saveDocument: "Guardar documento",
    refresh: "Actualizar",
    download: "Descargar",
    enable: "Habilitar",
    disable: "Deshabilitar",
    activate: "Activar",
    activated: "Activado",
    show: "Mostrar",
    delete: "Eliminar",
  },
  tables: {
    // Common table headers
    id: "Id",
    name: "Nombre",
    email: "Correo Electrónico",
    actions: "Acciones",
    status: "Estado",

    // Users table
    role: "Rol",

    // Directory table
    date: "Fecha",
    category: "Categoría",

    // Prompts table
    type: "Tipo",
    prompts: "Indicaciones",
    no: "No.",
    section: "Sección",
  },
  documentDetails: {
    fileDetails: "Detalles del Archivo",
    category: "Categoría",
    introduction: "Introducción",
    summary: "Resumen",
    metadata: "Metadatos",
    documentForCustomer: "Documento para Cliente",
    documentOf: "Documento de",
    documentDate: "Fecha del Documento",
    documentReference: "Referencia del Documento",
    filename: "Nombre del Archivo",

    // Analysis section
    analysis: "Análisis",
    signingTheContract: "Firma del Contrato",
    validity: "Validez",
    extension: "Extensión",
    renewal: "Renovación",
    annualAdjustment: "Ajuste Anual",
    subcontracting: "Subcontratación",
    subscriptionOfTheContract: "Suscripción del Contrato",
    reAdjustability: "Reajustabilidad",
    price: "Precio",
    intellectualProperty: "Propiedad Intelectual",
    deadlines: "Plazos",

    // Comments section
    comments: "Comentarios",
    budgetAvailable: "Presupuesto Disponible",
    guaranteeOfSeriousnessOffer: "Garantía de Seriedad de Oferta",
    guaranteeOfFaithfulCompliance: "Garantía de Fiel Cumplimiento",
    fines: "Multas",
    earlyTermination: "Terminación Anticipada",
    pay: "Pago",
    estimatedContractAmount: "Monto Estimado del Contrato",
    guarantees: "Garantías",
    offerValidity: "Validez de la Oferta",
    scope: "Alcance",
    evaluationCriteria: "Criterios de Evaluación",
    terminationOfContract: "Terminación del Contrato",
    confidentiality: "Confidencialidad",
    paymentTerm: "Plazo de Pago",
    budgetModification: "Modificación de Presupuesto",
    presentationOfWarranty: "Presentación de Garantía",
    extensionOfTheContractTerm: "Extensión del Plazo del Contrato",
    outsourcing: "Subcontratación",
    methodOfPayment: "Método de Pago",
    informationSecurity: "Seguridad de la Información",
    ownershipOfInformation: "Propiedad de la Información",

    // Technical Comments section
    technicalComments: "Comentarios Técnicos",
    applicableStandards: "Normas Aplicables",
    requiredResources: "Recursos Requeridos",
    trainings: "Capacitaciones",
    averageMonthlyConsumption: "Consumo Mensual Promedio",
    emergencyService: "Servicio de Emergencia",
    correctiveMaintenance: "Mantenimiento Correctivo",
    technicalRequirements: "Requisitos Técnicos",
    trainingPlan: "Plan de Capacitación",
    maintenance: "Mantenimiento",
    executionDeadlines: "Plazos de Ejecución",
    staffRequired: "Personal Requerido",

    // Messages
    documentSavedSuccessfully: "Documento Guardado Exitosamente",
  },
  sections: {
    general: "General",
    analysis: "Análisis",
    comments: "Comentarios",
    technicalComments: "Comentarios Técnicos",
  },
  messages: {
    refreshing: "Actualizando...",
    loading: "Cargando...",
  },
};
